import AgTechIconBadge from "../../../Icons/AgTechIconBadge";
import { AgTechTabbedPageTabProps, AgTechTabPageTemplate, AgTechTabbedPageTab, AgTechTabPageTabClasses } from "../../../Pages/Tabbed/AgTechTabPage";

export type AgTechMultiPageTabPageProps = {
    tabs: AgTechTabbedPageTabProps[],
    title: string,
    icon?: string,
    paneContent?: () => React.ReactNode,
    tabContent?: () => JSX.Element,
    classes?: {
        header?: string,
        tabs?: AgTechTabPageTabClasses,
        tabContainer?: string
    },
    height?: number
}

const AgTechMultiPageTabPage = (props: AgTechMultiPageTabPageProps) => {
    return (
        <AgTechTabPageTemplate
            tabs={props.tabs}
            body={{
                classes: 'p-4'
            }}
            panel={() => (
                <div className={`flex-row wide bg-white border rounded px-4 ${props.classes?.header ?? ''} flex`} style={{ height: props.height ?? 108 }}>
                    <div className="row-based pt-2 flex">
                        <div className="wide flexed container">
                            <div className="tall flex-row pr-4 flex">
                                <div className="flex-row vertically-centered flex">
                                    {props.icon ? <AgTechIconBadge icon={props.icon} iconClasses='mr-4' /> : null }
                                    <h1 className='text-2xl font-semibold ml-[2px]'>{props.title}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='flexed flex' />
                        <div className={`vertically-centered ${props.classes?.tabContainer ?? ''} flex`}>
                            {props.tabs.map(tab => (
                                <AgTechTabbedPageTab
                                    key={props.title + tab.text}
                                    {...tab}
                                    classes={props.classes?.tabs ?? {
                                        tab: 'min-w-[92px] centered font-semibold mr-4 px-4 pb-2',
                                        active: 'border-b-2 clear-bordered text-secondary',
                                        inactive: 'border-b-2 border-b-highlight'
                                    }}
                                />
                            ))}
                        </div>
                        {props.tabContent && (
                            <div className="ml-auto flex">
                                {props.tabContent()}
                            </div>
                        )}
                    </div>
                    {props.paneContent && (
                        <div className="flex-col tall ml-auto py-2 flex">
                            {props.paneContent()}
                        </div>
                    )}
                </div>
            )}
        />
    )
};

export default AgTechMultiPageTabPage;